import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthLetterExtractionState {
  loadingByDocument: Record<string, boolean>;
  loadingByJCode: Record<string, boolean>;
  documentPathByJCode: Record<string, string>;
  latestDocumentByJCode: Record<
    string,
    { documentPath: string; documentTitle: string }
  >;
}

interface SetAuthLetterExtractionLoadingPayload {
  orderId: string;
  documentPath: string;
  jCodeIds: string[];
  documentTitle: string;
  isLoading: boolean;
}

const initialState: AuthLetterExtractionState = {
  loadingByDocument: {},
  loadingByJCode: {},
  documentPathByJCode: {},
  latestDocumentByJCode: {},
};

const getDocumentKey = (orderId: string, documentPath: string): string =>
  `${orderId}:${documentPath}`;
const getJCodeKey = (orderId: string, jCodeId: string): string =>
  `${orderId}:${jCodeId}`;

const authLetterExtractionSlice = createSlice({
  name: "authLetterExtraction",
  initialState,
  reducers: {
    setAuthLetterExtractionLoading: (
      state,
      action: PayloadAction<SetAuthLetterExtractionLoadingPayload>,
    ) => {
      const { orderId, documentPath, jCodeIds, documentTitle, isLoading } =
        action.payload;
      const documentKey = getDocumentKey(orderId, documentPath);

      if (isLoading) {
        state.loadingByDocument[documentKey] = true;
        jCodeIds.forEach((jCodeId) => {
          const jCodeKey = getJCodeKey(orderId, jCodeId);
          state.loadingByJCode[jCodeKey] = true;
          state.documentPathByJCode[jCodeKey] = documentPath;
          state.latestDocumentByJCode[jCodeKey] = {
            documentPath,
            documentTitle,
          };
        });
      } else {
        delete state.loadingByDocument[documentKey];
        jCodeIds.forEach((jCodeId) => {
          const jCodeKey = getJCodeKey(orderId, jCodeId);
          delete state.loadingByJCode[jCodeKey];
          delete state.documentPathByJCode[jCodeKey];
        });
      }
    },
  },
});

export const { setAuthLetterExtractionLoading } =
  authLetterExtractionSlice.actions;

export const getAuthLetterExtractionKey = getDocumentKey;
export const getAuthLetterExtractionJCodeKey = getJCodeKey;

export default authLetterExtractionSlice.reducer;
